import ServiceRangesTable from './ServiceRangesTable'
export default ServiceRangesTable